import putLoanApplicationApiCall from 'api/calls/putLoanApplicationApiCall';
import useProtectedMutation from './useProtectedMutation';

const usePutLoanApplicationMutation = () =>
  useProtectedMutation(putLoanApplicationApiCall);

export default usePutLoanApplicationMutation;
